/* ============================================================
   KICK SPEED - fixes for the Motion theme script (assets/ks-theme-fixes.js)
   Loaded from layout/theme.liquid right after theme.js (both defer, so
   this runs after theme.js and before the page is ready).

   Cart drawer: CartDrawer.open() in theme.js runs
     setTimeout(function () {
       theme.a11y.trapFocus({ container: this.drawer, elementToFocus: this.form, ... })
     }, 100)
   without .bind(this), so `this.drawer` is undefined there and every
   opening of the cart threw "Cannot read properties of undefined
   (reading 'querySelectorAll')". The drawer already keeps the focus
   inside itself (theme.Drawers.open, namespace drawer_focus), so that
   broken second call is skipped here instead of throwing.
   CartDrawer.close() hands removeTrapFocus the theme.Drawers object
   instead of the element; that would throw on removeAttribute, so the
   object is dropped and only the focus listeners are removed.
   Nothing else changes.

   Product gallery: snippets/product-images.liquid loads only the first
   two pictures at once, the rest lazily. So that a swipe or a tap on a
   thumbnail never shows an empty slide, the slides around the one on
   screen are fetched as soon as the shopper touches the gallery and
   after every change of slide.

   Background videos from YouTube (hero video, background video with
   text): the theme creates their player with autoplay but without mute
   in its address and mutes it only once the player is ready. An iPhone
   does not start a video with sound on its own, so the first start is
   refused, the later one often too, and the section waits for a tap
   (the play sign in the corner). Asked for muted and inline from the
   start (mute=1, playsinline=1, autoplay=1), the player can start by
   itself. Product videos keep the theme's own settings.
   ============================================================ */
(function () {
  'use strict';
  var a11y = window.theme && window.theme.a11y;
  if (!a11y || a11y.__ksFixed) return;
  a11y.__ksFixed = true;

  function isEl(x) { return !!(x && x.nodeType === 1); }

  var trap = a11y.trapFocus;
  if (typeof trap === 'function') {
    a11y.trapFocus = function (options) {
      if (!options || !isEl(options.container)) return;
      return trap.apply(this, arguments);
    };
  }

  var untrap = a11y.removeTrapFocus;
  if (typeof untrap === 'function') {
    a11y.removeTrapFocus = function (options) {
      if (options && options.container && !isEl(options.container)) {
        options = Object.assign({}, options, { container: null });
      }
      return untrap.call(this, options);
    };
  }

  /* ---------- product gallery: fetch the slides next to the one on screen ---------- */
  var SLIDE = '.product-main-slide';
  function warm(slide) {
    if (!slide) return;
    var imgs = slide.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) imgs[i].loading = 'eager';
  }
  function warmAround(gallery) {
    if (!gallery) return;
    var cur = gallery.querySelector(SLIDE + '.is-selected') || gallery.querySelector(SLIDE + '.starting-slide') || gallery.querySelector(SLIDE);
    if (!cur) return;
    var next = cur.nextElementSibling;
    warm(cur);
    warm(next);
    warm(next && next.nextElementSibling);
    warm(cur.previousElementSibling);
  }
  function galleryOf(target) {
    var box = target && target.closest ? target.closest('[data-product-images]') : null;
    return box ? box.querySelector('[data-product-photos]') : null;
  }
  /* first touch / hover: the neighbours start loading before the swipe ends */
  function early(e) { warmAround(galleryOf(e.target)); }
  /* after a swipe or a thumbnail tap the theme selects the new slide */
  function late(e) {
    var g = galleryOf(e.target);
    if (!g) return;
    setTimeout(function () { warmAround(g); }, 60);
    setTimeout(function () { warmAround(g); }, 450);
  }
  document.addEventListener('touchstart', early, { passive: true, capture: true });
  document.addEventListener('pointerdown', early, { passive: true, capture: true });
  document.addEventListener('mouseover', function (e) {
    var g = galleryOf(e.target);
    if (g && !g.__ksWarm) { g.__ksWarm = true; warmAround(g); }
  }, { passive: true });
  document.addEventListener('touchend', late, { passive: true, capture: true });
  document.addEventListener('pointerup', late, { passive: true, capture: true });
  document.addEventListener('click', late, { passive: true, capture: true });
  /* a colour change moves the gallery to that colour's picture */
  document.addEventListener('variant:change', function () {
    setTimeout(function () {
      var all = document.querySelectorAll('[data-product-photos]');
      for (var i = 0; i < all.length; i++) warmAround(all[i]);
    }, 120);
  });

  /* ---------- background videos from YouTube: start muted ---------- */
  var YTPlayer = window.theme.YouTube;
  if (typeof YTPlayer === 'function' && !YTPlayer.__ksMuted) {
    var MutedYouTube = function (divId, options) {
      var o = options || {};
      if (o.videoParent === '.video-parent-section') {
        o = Object.assign({}, o, {
          autoplay: true,
          playerVars: {
            autohide: 0, autoplay: 1, mute: 1, playsinline: 1,
            cc_load_policy: 0, controls: 0, fs: 0, iv_load_policy: 3,
            modestbranding: 1, rel: 0
          }
        });
      }
      return new YTPlayer(divId, o);
    };
    MutedYouTube.prototype = YTPlayer.prototype;
    MutedYouTube.__ksMuted = true;
    window.theme.YouTube = MutedYouTube;
  }
})();
